var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.5362,
    y1: 107.2936,
    x2: 44.5362,
    y2: -0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009406354,
    style: {
      stopColor: "#DC0000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6C00"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.6,30.35L30.6,30.35l-0.02,0.02L30.6,30.35z M69.86,29.62c-0.27-0.26-0.58-0.5-0.91-0.69 c-1.88-1.1-4.29-0.48-5.4,1.4c-0.04,0.07-0.08,0.15-0.12,0.22c-1.36,2.68-3.23,5.06-5.51,7.01c0.35-1.97,0.52-3.96,0.53-5.95 c0.01-12.36-6.61-23.78-17.35-29.9c-1.89-1.07-4.3-0.41-5.38,1.49c-0.29,0.52-0.47,1.1-0.5,1.69c-0.45,7.56-3.97,14.6-9.74,19.49 l-0.91,0.74c-2.99,2.01-5.64,4.49-7.84,7.34c-12.16,15.32-9.6,37.61,5.72,49.77c2.64,2.1,5.57,3.81,8.69,5.07 c2.01,0.82,4.32-0.14,5.14-2.16c0.19-0.47,0.29-0.98,0.29-1.49c0-0.42-0.07-0.83-0.2-1.23c-0.88-3.32-1.14-6.77-0.75-10.18 c3.73,7.04,9.72,12.62,17.01,15.84c0.89,0.4,1.89,0.45,2.82,0.15c18.64-6.02,28.88-26.01,22.86-44.65 C76.61,38.33,73.72,33.55,69.86,29.62z M54.46,80.21c-6.95-3.52-12.08-9.83-14.1-17.36c-0.31-1.25-0.54-2.52-0.71-3.8 c-0.23-1.67-1.5-3.01-3.15-3.33c-0.25-0.05-0.5-0.07-0.75-0.07c-1.41,0-2.71,0.75-3.42,1.98c-3.27,5.64-4.92,12.08-4.75,18.6 c-12.01-9.34-14.18-26.64-4.84-38.65c0.07-0.09,0.14-0.17,0.2-0.26c1.72-2.24,3.81-4.18,6.16-5.75c0.1-0.07,0.2-0.14,0.29-0.22 c0,0,1.17-0.97,1.21-0.99c5.62-4.75,9.61-11.14,11.43-18.27c8.83,8.17,11.08,21.25,5.47,31.89c-1.01,1.93-0.26,4.31,1.67,5.32 c0.92,0.48,2,0.58,3,0.27c6.04-1.89,11.36-5.59,15.23-10.6c8.55,12.63,5.24,29.79-7.38,38.34C58.27,78.49,56.41,79.46,54.46,80.21 L54.46,80.21z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotIcon);
export default __webpack_public_path__ + "static/media/hot-icon.92999e6c692bcbc2fcbb9c0f443bf207.svg";
export { ForwardRef as ReactComponent };